import React, {PropTypes} from 'react';
import ResultsNotFound from '../ResultsNotFound.jsx';
import AuditBowlerDetailContainer from './AuditBowlerDetailContainer.jsx';
import AuditBowlerHeaderContainer from './AuditBowlerHeaderContainer.jsx';

const AuditBowlerDetailList = ({
  list,
  headerBowler
}) => ( 
  <div className="animated fadeIn"> 
    <div className="panel panel-primary">
      <div className="panel-heading row">
        <div className="col-sm-12">
          <h4 className="panel-title">{'Bowler'}</h4>
        </div> 
      </div>
      <div className="panel-body">
        <div className="list-group">
          <AuditBowlerHeaderContainer
            {...headerBowler} /> 
        </div> 
      </div>
    </div>
    <div className="panel panel-primary">
      <div className="panel-heading row">
        <div className="col-sm-12">
          <h4 className="panel-title">{'Bowler History'}</h4>
        </div> 
      </div>
      <div className="panel-body"> 
        { list && list.length == 0 ? <ResultsNotFound/> : null }
        <div className="list-group">
          { list ? list.map((item, index) => (
            <AuditBowlerDetailContainer key={index}   
                       {...item}      
                       showLink /> 
            )) : null}
        </div>
      </div>
    </div>
  </div>
);

AuditBowlerDetailList.defaultProps = {  
};

AuditBowlerDetailList.propTypes = {  
  list: PropTypes.arrayOf(PropTypes.object),
  headerBowler: PropTypes.object
};

export default AuditBowlerDetailList; 


// WEBPACK FOOTER //
// ./src/features/admin/audit/bowlerAudit/AuditBowlerDetailList.jsx